<template>
<article class="communication sub-content">
  <header class="communication__header">
    <h1 v-html="$t('communication.title')"/>
    <p>{{$t('communication.description')}}</p>
  </header>
  <nav v-if="faq.groups.length > 0" class="categories">
    <button
      v-for="(item,key) in faq.groups"
      type="button"
      :disabled="key === activeItemKey"
      @click="onChangeCategory(key)">
      <span>{{item.label}}</span>
    </button>
  </nav>
  <div v-if="state.faq?.length > 0" class="faq-sections">
    <section v-for="(section, sectionKey) in state.faq" class="faq">
      <h1 class="faq__title">{{section.title}}</h1>
      <ul class="faq__items">
        <li
          v-for="(item, itemKey) in section.items"
          :class="[
            'faq-item',
            (state.openItem[0] === sectionKey && state.openItem[1] === itemKey) && 'faq-item--on',
          ]">
          <button type="button" class="faq-item__control" @click="onClickToggleItem(sectionKey, itemKey)">
            <span>
              <strong>{{item.label}}</strong>
              <Icon icon-name="arrow-down"/>
            </span>
          </button>
          <article v-html="item.body" class="markdown faq-item__body"/>
        </li>
      </ul>
    </section>
  </div>
  <section class="good-idea">
    <h1 class="good-idea__title">
      {{$t('communication.idea.title')}}
    </h1>
    <p class="good-idea__description">
      {{$t('communication.idea.description')}}
    </p>
    <nav class="good-idea__nav">
      <ButtonRoundFull @click="onClickContactUs">
        {{$t('communication.idea.register')}}
      </ButtonRoundFull>
    </nav>
  </section>
</article>
</template>

<script setup>
import { ref, reactive, watch } from 'vue'
import { marked } from 'marked'
import { faqStore } from '~/store/communication'
import { navigationStore } from '~/store/navigation'
import { pureObject } from '~/libs/util'
import Icon from '~/components/icon/index.vue'
import ButtonRoundFull from '~/components/button/round-fill.vue'

definePageMeta({
  middleware: 'service',
})

const faq = faqStore()
const navigation = navigationStore()
const activeItemKey = ref(0)
const state = reactive({
  faq: convertFaqItems(activeItemKey.value),
  openItem: [ undefined, undefined ],
})

function convertFaqItems(key)
{
  let newItems = pureObject(faq.groups[key]?.children || [])
  for (let i = 0; i < newItems.length; i++)
  {
    if (newItems[i].items?.length > 0)
    {
      for (let j = 0; j < newItems[i].items.length; j++)
      {
        newItems[i].items[j].body = marked(newItems[i].items[j].body)
        newItems[i].items[j].open = false
      }
    }
  }
  return newItems
}

function onChangeCategory(key)
{
  activeItemKey.value = key
}

function onClickToggleItem(sectionKey, itemKey)
{
  if (state.openItem[0] === sectionKey && state.openItem[1] === itemKey)
  {
    state.openItem[0] = undefined
    state.openItem[1] = undefined
    return
  }
  state.openItem[0] = sectionKey
  state.openItem[1] = itemKey
}

function onClickContactUs()
{
  location.href = `mailto:${navigation.contactEmail}`
}

watch(() => activeItemKey.value, (value) => {
  state.openItem[0] = undefined
  state.openItem[1] = undefined
  state.faq = convertFaqItems(value)
})
</script>

<style src="../../assets/scss/markdown.scss" lang="scss"></style>
<style src="./index.scss" lang="scss" scoped></style>
